/**
 *
 * SignupParent
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

// styles
import './style.scss';

import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer from './reducer';
import saga from './saga';

// import {} from './actions';

// import {} from './selectors';

// antd component
import { Button, Form, message } from 'antd';

// layouts
import Preloader from 'components/Preloader';

// components
import QrScanner from 'mobile/components/QrScanner';

// forms helpers
import CustomForm from 'components/Forms/CustomForm';
import { initFormsByRole } from 'utils/forms/forms.init';

// utils
import api, { setAuthorizationHeader } from 'utils/apis/axiosAPI';

// global user
import { useGetLocalUser, useInitUser } from 'engine/Contexts/User.context';

// hooks
import { useAuthRole } from 'utils/hooks';

export function SignupParent({ roles, history }) {
  useInjectReducer({ key: 'signupParent', reducer });
  useInjectSaga({ key: 'signupParent', saga });

  const initRole = 'parent';
  const initForm = initFormsByRole(initRole);

  const [newParent, setNewParent] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showQR, setShowQR] = useState(true);
  const [spinner, setSpinner] = useState(false);
  const [student, setStudent] = useState(false);
  const [code, setCode] = useState('');

  // Form initialization for "general" tab
  const [customForm] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  setAuthorizationHeader();

  const localUser = useGetLocalUser()();
  const reInitUser = useInitUser();
  const isAuthRole = useAuthRole(roles);

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    if (window.location.pathname.includes('/signupparent')) {
      if (!!isAuthRole) {
        history.push('/linkstudent');
      } else if (
        (!!localUser?.token && (
          localUser?.role == 'teacher') || localUser?.role == 'admin'
        )
      ) {
        history.push('/404');
      } else {
        setNewParent(true);
      }
    } else {
      if (localUser?.role != 'parent') {
        history.push('/signupparent');
      } else {
        setNewParent(false);
      }
    }

    hideTab();
    // Anything in here is fired on component unmount.
    setSpinner(false);
  }, []);

  const hideTab = async () => {
    if (!localUser) {
      [].forEach.call(
        document.querySelectorAll('.fixed-nav-mobile'),
        function(el) {
          el.style.visibility = 'hidden';
        },
      );
    }
  };

  const redirectionMessageNewParent = () => {
    messageApi
      .open({
        type: 'loading',
        content: 'Création de votre compte parent en cours...',
        duration: 5,
      })
      .then(() => {
        message.success(
          'Compte créé avec succès! Vous allez être redirigé automatiquement',
          5,
        );
        reInitUser();
      })
      .then(() => history.push('/login'));
  };

  const redirectionMessageLink = () => {
    messageApi
      .open({
        type: 'loading',
        content: "Ajout de l'étudiant en cours...",
        duration: 5,
      })
      .then(() => {
        message.success(
          'Etudiant ajouté avec succès! Vous allez être redirigé automatiquement. Merci de vous déconnecter et reconnecter afin de voir votre nouvel enfant dans l’application.',
          5,
        );
        reInitUser();
      })
      .then(() => history.push('/home'));
  };

  const handleResultNewParent = code => {
    setCode(code);
    api.students
      .validateToken(code)
      .then(result => {
        setStudent(result);
        setShowForm(true);
        setShowQR(false);
        return result;
      })
      .catch(err => {
        setStudent(false);
        setShowForm(false);
        setShowQR(true);
        message.error(`QR Code non valide`, 5);
        console.error('is not valid', err);
      });
  };

  const handleResultLink = code => {
    setCode(code);
    api.students
      .validateToken(code)
      .then(async result => {
        setStudent(result);
        setShowQR(false);
        let payload = {
          newUserId: localUser?._id,
          studentId: result?._id,
        };
        api.users
          .linkStudent(payload)
          .then(result => {
            if (result) {
              redirectionMessageLink();
            } else {
              message.error('Un problème est survenu', 5);
            }
          })
          .catch(err => {
            message.error(err.message, 5);
          });
      })
      .catch(err => {
        setStudent(false);
        setShowQR(true);
        message.error(`QR Code non valide`, 5);
      });
  };

  const onSubmitForm = async data => {
    if (data?.description) {
      api.auth
        .signUp(data)
        .then(newUser => {
          if (!!newUser?.code && newUser?.code != 200) {
            message.error(newUser?.message, 5);
          } else {
            let payload = {
              newUserId: newUser?._id || newUser?.user?._id,
              studentId: student?._id,
            };
            
            setAuthorizationHeader(newUser?.token || newUser?.user?.token);

            api.users
              .linkStudent(payload)
              .then(result => {
                if (result) {
                  redirectionMessageNewParent();
                } else {
                  message.error('Un problème est survenu', 5);
                }
              })
              .catch(err => {
                message.error(err.message, 5);
              });
          }
        })
        .catch(err => {
          console.error({ err });
          message.error(err.message, 5);
        });
    }
  };

  // render function
  return (
    <>
      {spinner && <Preloader fullWidth />}
      {!spinner && (
        <>
          <div className="login-page signup-parent-page">
            {!!newParent && (
              <div className="login-form__column register-parent">
                {showQR && (
                  <h4>
                    Vous avez reçu par la poste un QR code unique lié à un
                    étudiant.
                  </h4>
                )}
                {contextHolder}
                {showQR && (
                  <QrScanner
                    getResult={code => handleResultNewParent(code)}
                  />
                )}
                {showForm && (
                  <CustomForm
                    name={`users-general-form-new-parent`}
                    className="register-user-form"
                    method="new"
                    form={customForm}
                    dataSource={initForm}
                    handleSubmit={data => onSubmitForm(data)}
                    // handleChange={onFormChange}
                    // handleValuesChange={onFormValuesChange}
                    labelCol={24}
                    wrapperCol={24}
                  />
                )}
                <Button
                  type="primary"
                  htmlType="cancel"
                  block
                  size="large"
                  className="back-login"
                  loading={false}
                  onClick={() => history.push('/login')}
                >
                  Revenir au login
                </Button>
              </div>
            )}
            {!newParent && (
              <div className="login-form__column register-parent">
                {showQR && (
                  <h4>
                    Vous avez reçu par la poste un QR code unique lié à un
                    étudiant.
                  </h4>
                )}
                {contextHolder}
                {showQR && (
                  <QrScanner getResult={code => handleResultLink(code)} />
                )}
              </div>
            )}
            <svg
                className="waves"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 24 150 28"
                preserveAspectRatio="none"
                shapeRendering="auto"
              >
                <defs>
                  <path
                    id="gentle-wave"
                    d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
                  />
                </defs>
                <g className="parallax">
                  <use
                    href="#gentle-wave"
                    x="48"
                    y="0"
                    fill="rgba(255,255,255,0.7"
                  />
                  <use
                    href="#gentle-wave"
                    x="48"
                    y="3"
                    fill="rgba(255,255,255,0.5)"
                  />
                  <use
                    href="#gentle-wave"
                    x="48"
                    y="5"
                    fill="rgba(255,255,255,0.3)"
                  />
                  <use href="#gentle-wave" x="48" y="7" fill="#fff" />
                </g>
              </svg>
          </div>
        </>
      )}
    </>
  );
}

SignupParent.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(SignupParent);
